export default __webpack_public_path__ + "static/media/beep-01.f98f5301.mp3";